export default __webpack_public_path__ + "assets/enterprise-three-one-small.0e8047447106bf22cb3a7b7c82585c81.png";